import { PALETTES_SERVICE } from "@/services/palettes.service.js";

const state = {getPalettesOutput: {}, postPaletteOutput: false, putPaletteOutput: false, deletePaletteByIdOutput: false, getPaletteByIdOutput: {}};

const actions = {
    //Service to create palettes
    getPalettes({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getPalettesRequest');

        PALETTES_SERVICE.getPalettes(queryParams)
            .then(
                output => {
                    commit('getPalettesSuccess', output);
                },
                error => {
                    commit('getPalettesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create palettes
    postPalette({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postPaletteRequest');

        PALETTES_SERVICE.postPalette(input)
            .then(
                output => {
                    commit('postPaletteSuccess', output);
                },
                error => {
                    commit('postPaletteFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update palettes
    putPalette({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putPaletteRequest');

        PALETTES_SERVICE.putPalette(input)
            .then(
                output => {
                    commit('putPaletteSuccess', output);
                },
                error => {
                    commit('putPaletteFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove palettes
    deletePaletteById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deletePaletteByIdRequest');

        PALETTES_SERVICE.deletePaletteById(id)
            .then(
                output => {
                    commit('deletePaletteByIdSuccess', output);
                },
                error => {
                    commit('deletePaletteByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get palette details
    getPaletteById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getPaletteByIdRequest');

        PALETTES_SERVICE.getPaletteById(id)
            .then(
                output => {
                    commit('getPaletteByIdSuccess', output);
                },
                error => {
                    commit('getPaletteByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getPalettes
    getPalettesRequest(state) {
    },
    getPalettesSuccess(state, output) {
        state.getPalettesOutput = output;
    },
    getPalettesFailure(state) {
        state.getPalettesOutput = false;
    },

    //postPalette
    postPaletteRequest(state) {
        state.postPaletteOutput = null;
    },
    postPaletteSuccess(state, output) {
        state.postPaletteOutput = true;
    },
    postPaletteFailure(state) {
        state.postPaletteOutput = false;
    },

    //putPalette
    putPaletteRequest(state) {
        state.putPaletteOutput = null;
    },
    putPaletteSuccess(state, output) {
        state.putPaletteOutput = true;
    },
    putPaletteFailure(state) {
        state.putPaletteOutput = false;
    },

    //deletePaletteById
    deletePaletteByIdRequest(state) {
        state.deletePaletteByIdOutput = null;
    },
    deletePaletteByIdSuccess(state, output) {
        state.deletePaletteByIdOutput = true;
    },
    deletePaletteByIdFailure(state) {
        state.deletePaletteByIdOutput = false;
    },

    //getPaletteById
    getPaletteByIdRequest(state) {
    },
    getPaletteByIdSuccess(state, output) {
        state.getPaletteByIdOutput = output;
    },
    getPaletteByIdFailure(state) {
        state.getPaletteByIdOutput = false;
    },
};

export const palettes = {
    namespaced: true,
    state,
    actions,
    mutations
};